











































import mixins from 'vue-typed-mixins';
import { FunctionalCenter } from '../../utils/FunctionalCenterUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => FunctionalCenter,
    },
  },
  computed: {
    internal: {
      get(): FunctionalCenter {
        return this.value || {};
      },
      set(functionalcenter: FunctionalCenter) {
        this.$emit('input', functionalcenter);
      },
    },
  },
});
